export const phrases = [
  "(Child noises in the background)",
  "Hello, hello?",
  "I need to jump in another call",
  "Can everyone go on mute",
  "Could you please get closer to the mic",
  "(Loud painful echo/feedback)",
  "Next slide please",
  "Can we take this offline",
  "Is __ on this call?",
  "Could you share these slides afterward?",
  "Can somebody grant presenter rights?",
  "Can you email that to everyone?",
  "Sorry, I had a problem logging in",
  "(Animal noises in the background)",
  "Sorry, I didn't find the conference ID",
  "I was having connection issues",
  "I'll have to get back to you",
  "Who just joined?",
  "Sorry, something __ with my calendar",
  "Do you see my screen?",
  "Let's wait for ___",
  "You will send the minutes",
  "Sorry, I was on mute",
  "Can you repeat, please?",
];
